module.exports = __webpack_public_path__ + "static/img/about2.bb81fb7.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/about2.png
// module id = lgkH
// module chunks = 1